import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

/** GET branding info for the public apply form — no auth required */
export const FetchApplyFormInfo = ({ slug }) => {
    return useQuery(
        ['apply-form-info', slug],
        () =>
            axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/public/${slug}/apply-form`,
            }),
        {
            select: (data) => data?.data,
            enabled: !!slug,
            refetchOnWindowFocus: false,
            retry: 1,
        }
    );
};

/** POST startup application — no auth required, multipart/form-data */
export const SubmitApplyForm = () => {
    return useMutation(({ slug, payload }) =>
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/investors/public/${slug}/apply-form`,
            headers: { 'Content-Type': 'multipart/form-data' },
            data: payload,
        })
    );
};

/** POST send OTP to email — no auth required */
export const SendApplyFormOtp = () => {
    return useMutation(({ email }) =>
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/investors/public/apply-form/send-otp`,
            data: { email },
        })
    );
};

/** POST verify OTP — no auth required */
export const VerifyApplyFormOtp = () => {
    return useMutation(({ email, otp, slug }) =>
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/investors/public/apply-form/verify-otp`,
            data: { email, otp, slug },
        })
    );
};
